import API from './API.js'

export default class Loans extends API {
  constructor() {
    super('loans')
  }
}
